export default "__VITE_ASSET__Bg9Ef9CS__"